module.exports = __webpack_public_path__ + "static/media/IMG_5048.5bb9a800.JPG";